import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-selecionar-endereco-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatButtonModule,
  ],
  templateUrl: './selecionar-endereco-modal.html',
  styleUrl: './selecionar-endereco-modal.scss',
})
export class SelecionarEnderecoModal {
  constructor(
    public dialogRef: MatDialogRef<SelecionarEnderecoModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  @ViewChild(MatSort) sort!: MatSort;

  enderecos: any[] = [];
  enderecosExibidos: any[] = [];
  enderecoSelecionadoId: any = null;

  filterValue: string = '';

  ngOnInit(): void {
    if (!this.data.empresaSelecionada) {
      this.fechar();
      return;
    }

    this.enderecos = this.data.empresaSelecionada.enderecos;
    this.enderecosExibidos = this.enderecos;
  }

  filtraValores() {
    const filtro = this.filterValue.toLowerCase();
    this.enderecosExibidos = this.enderecos.filter((e) =>
      (e.labelEndereco ?? '').toLowerCase().includes(filtro)
    );
  }

  fechar(): void {
    this.dialogRef.close();
  }

  vincularEndereco() {
    const _enderecoSelecionado = this.enderecos.find(
      (e: any) => e.idEstabelecimento === this.enderecoSelecionadoId
    );

    this.dialogRef.close(_enderecoSelecionado);
  }
}
